export const initStates = {
  page: 0,
};
